import React from 'react';
import {AppLink} from './AppLink/AppLink';
import {Copyright} from './Copyright/Copyright';
import {SocialLinks} from './SocialLinks/SocialLinks';
import {FooterItems} from './FooterItems/FooterItems';
import {NewsLetter}  from './NewsLetter/NewsLetter';


export class Footer extends React.Component {
  render() {
    return (
     
    <section id="footer-section">
      <div className="container">
       <AppLink/>
       <NewsLetter/>   
       <div className="row padded-sections">
         <FooterItems/>
         <SocialLinks/>
       </div>
        <Copyright/>
      </div>
    </section>
     
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js